module.exports = "/static/assets/388a295a1ca324fb12e819fc81a905f1.png";